"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSB = function FlagSB(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M214-120.29-190.4,144.65a7,7,0,0,0,4.46,1.71H209.54a7.07,7.07,0,0,0,7.06-7.06V-114.94a7,7,0,0,0-2.6-5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-114.94a7.06,7.06,0,0,0-7.06-7.06H197.27L-193,133.69v5.61a7.06,7.06,0,0,0,7.06,7.06h12.27L216.6-109.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-157.46-100l-3.78,11.34-11.95.09a1.19,1.19,0,0,0-.7,2.15l9.62,7.1-3.61,11.39A1.19,1.19,0,0,0-166-66.6l9.73-6.94,9.72,6.94a1.19,1.19,0,0,0,1.83-1.33l-3.61-11.39,9.61-7.1a1.19,1.19,0,0,0-.7-2.15l-11.94-.09L-155.19-100a1.2,1.2,0,0,0-2.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-66.43-100l-3.78,11.34-12,.09a1.19,1.19,0,0,0-.7,2.15l9.61,7.1-3.6,11.39A1.19,1.19,0,0,0-75-66.6l9.72-6.94,9.72,6.94a1.19,1.19,0,0,0,1.83-1.33l-3.6-11.39,9.61-7.1a1.19,1.19,0,0,0-.7-2.15l-12-.09L-64.17-100a1.19,1.19,0,0,0-2.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-111.95-59.44l-3.78,11.33-11.94.1a1.19,1.19,0,0,0-.7,2.15l9.61,7.1-3.6,11.39A1.18,1.18,0,0,0-120.54-26l9.73-6.94,9.72,6.94a1.19,1.19,0,0,0,1.83-1.33l-3.6-11.39,9.61-7.1a1.19,1.19,0,0,0-.7-2.15l-12-.1-3.78-11.33a1.2,1.2,0,0,0-2.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-157.46-18.88l-3.78,11.33-11.95.1a1.19,1.19,0,0,0-.7,2.15l9.62,7.1-3.61,11.39A1.19,1.19,0,0,0-166,14.52l9.73-6.95,9.72,7a1.19,1.19,0,0,0,1.83-1.33L-148.38,1.8l9.61-7.1a1.19,1.19,0,0,0-.7-2.15l-11.94-.1-3.78-11.33a1.2,1.2,0,0,0-2.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-66.43-18.88-70.21-7.55l-12,.1a1.19,1.19,0,0,0-.7,2.15l9.61,7.1-3.6,11.39A1.19,1.19,0,0,0-75,14.52l9.72-6.95,9.72,7a1.19,1.19,0,0,0,1.83-1.33L-57.35,1.8l9.61-7.1a1.19,1.19,0,0,0-.7-2.15l-12-.1-3.78-11.33a1.19,1.19,0,0,0-2.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSB;
exports["default"] = _default;